
(function () {
    'use strict';
  
    angular
      .module('cards')
      .config(config);
  
    function config($stateProvider) {
      $stateProvider
        .state('cards', {
          url: '/cards-overview',
          templateUrl: 'cards/views/cards-overview/cards-overview.tpl.html',
          controller: 'CardsOverviewCtrl',
          controllerAs: 'vm'
        })
        .state('card', {
          url: '/cards/:cardId',
          params: {
            step: 1
          },
          templateUrl: 'cards/views/card/card.tpl.html',
          controller: 'CardCtrl',
          controllerAs: 'vm'
        })
        .state('cardSign', {
          url: '/cards/:cardId/sign',
          params: {
            step: 2
          },
          templateUrl: 'cards/views/card/card.tpl.html',
          controller: 'CardCtrl',
          controllerAs: 'vm'
        })
        .state('cardSettings', {
          url: '/cards/:cardId/settings',
          templateUrl: 'cards/views/card-settings/card-settings.tpl.html',
          controller: 'CardSettingsCtrl',
          controllerAs: 'vm'
        });
    }
  }());
  